module.exports = __webpack_public_path__ + "img/New Year 7.f37bf710.jpeg";